import firebase from 'firebase/app'
import 'firebase/firestore'

var firebaseConfig = {
    apiKey: "AIzaSyCYpjvwD4-9TL1xuJIkORFOrVy6DreXmxc",
    authDomain: "nadal-30334.firebaseapp.com",
    databaseURL: "https://nadal-30334.firebaseio.com",
    projectId: "nadal-30334",
    storageBucket: "nadal-30334.appspot.com",
    messagingSenderId: "413298466047",
    appId: "1:413298466047:web:759e138a051466c76ac0ca",
    measurementId: "G-4F808301Q7"
};

// var firebaseConfigDev = {
//     apiKey: "AIzaSyD7m6NGP1_gVGFJO33B6LtjyH5VcN4BPGY",
//     authDomain: "nadal-dev.firebaseapp.com",
//     databaseURL: "https://nadal-dev.firebaseio.com",
//     projectId: "nadal-dev",
//     storageBucket: "nadal-dev.appspot.com",
//     messagingSenderId: "317762218621",
//     appId: "1:317762218621:web:953968b0c5c48d1896df14",
//     measurementId: "G-ZSJSWVN788"
// };
// Get a Firestore instance
export const db = firebase
    .initializeApp(firebaseConfig)
    .firestore()
firebase.auth()
// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }

// if using Firebase JS SDK < 5.8.0
db.settings({ timestampsInSnapshots: true })
